import Action from 'actions';
import BaseExecutor from 'services/sports/default/base-executor';
import CorrelationStackingBaseValidator from 'components/organisms/correlation-stacking/validators/correlation-stacking-base-validator';
import StackPlayersValidator from 'components/organisms/correlation-stacking/validators/stack-players-validator';
import CheckedAtLeastOneCombinationValidator from 'components/organisms/correlation-stacking/validators/checked-at-least-one-combination-validator';
import MaxStackAndCombinationPlayersQuantityValidator from 'components/organisms/correlation-stacking/validators/max-stack-and-combination-players-quantity-validator';
import SingleSecondaryStackCombinationsValidator from 'components/organisms/correlation-stacking/validators/single-secondary-stack-combinations-validator';
import DoubleSecondaryStackCombinationsValidator from 'components/organisms/correlation-stacking/validators/double-secondary-stack-combinations-validator';
import TotalMinExposureValidator from 'components/organisms/correlation-stacking/validators/total-min-exposure-validator';
import SecondaryDoubleStackCombinationsValidator from 'components/organisms/correlation-stacking/validators/secondary-double-stack-combinations-validator';
import KeyPlayerValidator from 'components/organisms/correlation-stacking/validators/key-player-validator';
import BaseValidator from 'services/validations/base-validator';

class CorrelationStackingValidatorBuilder extends BaseExecutor {
    getInterface() {
        const {
            correlationStacking: {settings: stacking},
            sportConfig,
            playersExclusion,
            lineupsQuantity,
            playersData: {preparedPlayers, players, filters: playersFilters},
        } = Action.getState();

        if (!stacking.isEnabled()) {
            return new BaseValidator();
        }

        const stackPlayersValidator = new StackPlayersValidator();
        stackPlayersValidator.setDependencies({
            stacking,
            players: preparedPlayers.groupedBy.playerId(),
        });

        const keyPlayerValidator = new KeyPlayerValidator();
        keyPlayerValidator.setDependencies({
            stacking,
            players,
            playersFilters,
            playersExclusion,
        });

        const totalMinExposureValidator = new TotalMinExposureValidator();
        totalMinExposureValidator.setDependencies({
            stacking,
            lineupsQuantity: lineupsQuantity.getLineupsQuantity(),
        });

        const checkedAtLeastOneCombinationValidator = new CheckedAtLeastOneCombinationValidator();
        checkedAtLeastOneCombinationValidator.setDependencies({stacking});

        const secondaryDoubleStackCombinationsValidator = new SecondaryDoubleStackCombinationsValidator();
        secondaryDoubleStackCombinationsValidator.setDependencies({stacking});

        const maxStackAndCombinationPlayersQuantityValidator = new MaxStackAndCombinationPlayersQuantityValidator();
        maxStackAndCombinationPlayersQuantityValidator.setDependencies({
            stacking,
            sportConfig,
        });

        const singleSecondaryStackCombinationsValidator = new SingleSecondaryStackCombinationsValidator();
        singleSecondaryStackCombinationsValidator.setDependencies({
            stacking,
            sportConfig,
        });

        const doubleSecondaryStackCombinationsValidator = new DoubleSecondaryStackCombinationsValidator();
        doubleSecondaryStackCombinationsValidator.setDependencies({
            stacking,
            sportConfig,
        });

        const validator = new CorrelationStackingBaseValidator();
        validator.setDependencies({stacking});
        validator.addSubValidators([
            stackPlayersValidator,
            keyPlayerValidator,
            totalMinExposureValidator,
            checkedAtLeastOneCombinationValidator,
            secondaryDoubleStackCombinationsValidator,
            maxStackAndCombinationPlayersQuantityValidator,
            singleSecondaryStackCombinationsValidator,
            doubleSecondaryStackCombinationsValidator,
        ]);

        return validator;
    }
}

export {CorrelationStackingValidatorBuilder};
